// extracted by mini-css-extract-plugin
export default {"btnAdd":"Courses_btnAdd__A8Wx0","iconActive":"Courses_iconActive__w4teQ","icon":"Courses_icon__IfiAs"};